import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/auth/register/add-employees/error/page";

export const Route = createFileRoute("/auth/register/add-employees/error")({
  component: Page,
});
